import { z } from "zod";
export var DmaSettingParameterKind;
(function (DmaSettingParameterKind) {
    DmaSettingParameterKind["Ingredient"] = "Ingredient";
    DmaSettingParameterKind["Number"] = "Number";
    DmaSettingParameterKind["NumberRange"] = "NumberRange";
    DmaSettingParameterKind["String"] = "String";
})(DmaSettingParameterKind || (DmaSettingParameterKind = {}));
export const dmaSettingParameterKindDtoSchema = z.nativeEnum(DmaSettingParameterKind);
